<template lang='pug'>
  .touch(:class="{swiped: swiped, up: swiped == 'up', right: swiped == 'right', down: swiped == 'down', left: swiped == 'left'}")
    slot(:swiped="swiped" :x="x" :y="y")
</template>

<script>
  export default {
    data() {
      return {
        offsetXStart: 0,
        x: 0,
        offsetXEnd: 0,
        offsetYStart: 0,
        y: 0,
        offsetYEnd: 0,
        swiped: '',
        swipes: 0
      }
    },

    mounted() {
      var self = this;
      
      self.$el.addEventListener('touchstart', e => {
        self.offsetXStart = e.touches[0].pageX - e.touches[0].target.offsetLeft;
        self.offsetXEnd = self.offsetXStart;

        self.offsetYStart = e.touches[0].pageY - e.touches[0].target.offsetTop;
        self.offsetYEnd = self.offsetYStart;
        self.$emit('tstart', self.offsetXStart, self.offsetYStart, e);
      });

      self.$el.addEventListener('touchmove', e => {
        self.offsetXEnd = e.touches[0].pageX - e.touches[0].target.offsetLeft;
        self.offsetYEnd = e.touches[0].pageY - e.touches[0].target.offsetTop;
        self.x = self.offsetXEnd - self.offsetXStart;
        self.y = self.offsetYEnd - self.offsetYStart;
        self.$emit('tmove', self.x, self.y, e);
      });

      self.$el.addEventListener('touchend', e => {
        var direction = null;
        var distance = 0;
        
        if (self.offsetXStart - self.offsetXEnd > 10) {
          direction = 'left';
          distance = self.offsetXStart - self.offsetXEnd;
        }
        if (self.offsetXStart - self.offsetXEnd < -10) {
          direction = 'right';
          distance = self.offsetXEnd - self.offsetXStart;
        }
        if (self.offsetYStart - self.offsetYEnd > 10 && self.offsetYStart - self.offsetYEnd > distance) {
          direction = 'up';
          distance = self.offsetYStart - self.offsetYEnd;
        }
        if (self.offsetYStart - self.offsetYEnd < -10 && self.offsetYEnd - self.offsetYStart > distance) {
          direction = 'down';
          distance = self.offsetYEnd - self.offsetYStart;
        }

        if (direction) {
          self.swiped = direction;
          self.swipes += 1;
          self.$emit(direction, distance);
        }
        self.x = 0;
        self.y = 0;

        self.$emit('tend', self.offsetXEnd, self.offsetYEnd, e);
      });
    }
  }
</script>
